import { h } from 'preact';
const LeftArrow = (props) => (
  <svg viewBox="0 0 72 72" class={props.class}>
    <polygon points="57,62 31,36 57,10 49,2 15,36 49,70"/>
	</svg>
);
export default LeftArrow;


// WEBPACK FOOTER //
// ../q-mdc/icons/left-arrow/index.js